import styled, { keyframes, css } from 'styled-components';
import { Item, Indicator, Root } from '@radix-ui/react-radio-group';

const scaleIn = keyframes `
    from {
        opacity: 0;
        transform: scale(0.8);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
`;
const InputWrapper = styled.div `
    display: flex;
    align-items: flex-start;
`;
const Label = styled.span `
    min-width: 0;
    ${({ theme }) => theme.typography.RegularParagraph};
    color: ${({ theme }) => theme.colors.text.darkerGrey};

    ${({ $disabled, theme }) => {
    if (!$disabled)
        return '';
    return css `
            color: ${theme.colors.text.baseGrey};
        `;
}}
`;
const LabelWrapper = styled.div `
    min-width: 0;
    display: flex;
    align-items: center;
    flex-grow: 1;
`;
const Radio = styled(Item) `
    padding: 0;
    width: 24px;
    height: 24px;
    background-color: ${({ theme }) => theme.colors.background.white};
    border: 1px solid ${({ theme }) => theme.colors.stroke.darkerGrey};
    border-radius: ${({ theme }) => theme.borderRadius.full};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-sizing: border-box;
    overflow: hidden;

    &[data-disabled] {
        border-color: ${({ theme }) => theme.colors.stroke.baseGrey};
        background-color: ${({ theme }) => theme.colors.background.superLightGrey};
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${({ theme }) => theme.shadows.focused};
    }
`;
const RadioIndicator = styled(Indicator) `
    width: 16px;
    height: 16px;
    background-color: ${({ theme }) => theme.colors.background.darkerGrey};
    border-radius: ${({ theme }) => theme.borderRadius.full};
    animation: ${scaleIn} 100ms cubic-bezier(0.2, 0, 0, 1);

    &[data-disabled] {
        background-color: ${({ theme }) => theme.colors.stroke.baseGrey};
    }
`;
const RadioWrapper = styled.label `
    width: fit-content;
    min-width: 0;
    background-color: ${({ theme }) => theme.colors.background.white};
    border-radius: 4px;
    display: flex;
    align-items: stretch;
    gap: ${({ theme }) => theme.spacers['2M']};
    box-sizing: border-box;
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

    ${({ $labelPlacement, theme }) => {
    if ($labelPlacement !== 'start')
        return '';
    return css `
            gap: ${theme.spacers.XL};
            width: 100%;

            ${LabelWrapper} {
                order: -1;
            }
        `;
}}
`;
const Wrapper = styled(Root) `
    display: flex;
    flex-direction: ${({ orientation }) => (orientation === 'horizontal' ? 'row' : 'column')};
    align-items: flex-start;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacers.L} ${({ theme }) => theme.spacers.XL};
`;

export { InputWrapper, Label, LabelWrapper, Radio, RadioIndicator, RadioWrapper, Wrapper };
